import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vdr-order-substitutes-label',
  templateUrl: './order-substitutes-label.component.html',
  styleUrls: ['./order-substitutes-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSubstitutesLabelComponent {
  @Input() entity;
}
